module.exports = __webpack_public_path__ + "static/img/stackable-pipeline-support_256.a313cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stackable-pipeline-support_256.png
// module id = czo+
// module chunks = 0